"use client";

import MediaImage from "@/components/ui/MediaImage";

import { getBorderRadius, getDesktop, getMobile } from "@/utils/theme-helper";

export interface ImageComponentProps {
  url: string;
  altText: string;
  height: string;
  width: string;
  objectFit: string;
  objectPosition?: string;
  rounded?: string;
  aspectRatio?: string;
  fill?: boolean;
  /** On a look-system website, where `rounded` may be an exact length. */
  lookSystem?: boolean;
}

const ImageComponent: React.FC<{
  config: ImageComponentProps;
}> = ({ config }) => {
  const mobileWidth = getMobile("w-full", config.width);
  const desktopWidth = getDesktop("w-full", config.width);
  const mobileHeight = getMobile("h-full", config.height);
  const desktopHeight = getDesktop("h-full", config.height);

  const mobileAspectRatio = getMobile("auto", config.aspectRatio);
  const desktopAspectRatio = getDesktop("auto", config.aspectRatio);

  if (!config.url) {
    return null;
  }

  const image = (
    <MediaImage
      {...(config.lookSystem && (config.objectFit ?? "cover") === "cover"
        ? { "data-re-frame-photo": "" }
        : {})}
      src={config.url}
      alt="billede"
      legacyAlt={config.altText}
      style={
        {
          "--mobile-width": mobileWidth,
          "--desktop-width": desktopWidth,
          "--mobile-height": mobileHeight,
          "--desktop-height": desktopHeight,
          objectPosition: config.objectPosition ?? "center",
          "--mobile-aspect-ratio": mobileAspectRatio,
          "--desktop-aspect-ratio": desktopAspectRatio,
          "--rounding-image-mobile": getBorderRadius(
            getMobile("", config.rounded),
            "image",
            config.lookSystem,
          ),
          "--rounding-image-desktop": getBorderRadius(
            getDesktop("", config.rounded),
            "image",
            config.lookSystem,
          ),
        } as React.CSSProperties
      }
      className={
        config.fill
          ? `absolute inset-0 h-full w-full object-${config.objectFit ?? "cover"}`
          : `homepage-image-rounded object-${config.objectFit ?? "cover"} ${mobileWidth !== "none" ? "w-[var(--mobile-width)]" : "w-full"} ${desktopWidth !== "none" ? "md:w-[var(--desktop-width)]" : "w-full"} ${mobileHeight !== "none" ? "h-[var(--mobile-height)]" : "h-full"} ${desktopHeight !== "none" ? "md:h-[var(--desktop-height)]" : "h-full"} overflow-hidden aspect-[var(--mobile-aspect-ratio)] md:aspect-[var(--desktop-aspect-ratio)]`
      }
    />
  );
  return config.fill ? (
    <div
      className="re-image-fill homepage-image-rounded overflow-hidden"
      style={
        {
          "--re-image-fill-height": mobileHeight,
          "--re-image-fill-height-desktop": desktopHeight,
          "--re-image-fill-ratio": mobileAspectRatio,
          "--re-image-fill-ratio-desktop": desktopAspectRatio,
          "--rounding-image-mobile": getBorderRadius(
            getMobile("", config.rounded),
            "image",
            config.lookSystem,
          ),
          "--rounding-image-desktop": getBorderRadius(
            getDesktop("", config.rounded),
            "image",
            config.lookSystem,
          ),
        } as React.CSSProperties
      }
    >
      {image}
    </div>
  ) : (
    image
  );
};

export default ImageComponent;
